
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products-bussiness/leasing",
      function () {
        return require("private-next-pages/products-bussiness/leasing/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products-bussiness/leasing"])
      });
    }
  